export default __webpack_public_path__ + "static/media/image_1.f9015d88.jpg";